query MailerConfigEdit($id: ID!) {
  mailerConfig(id: $id) {
    id
    title
    from
    siteUrl
    logo {
      id
      url
    }
    siteName
    siteEmail
  }
}
